export default "__VITE_ASSET__ip3eJ_90__"